export const userinfoConstants = {
    LOAD_REQUEST: 'USERINFO_LOAD_REQUEST',
    LOAD_SUCCESS: 'USERINFO_LOAD_SUCCESS',
    LOAD_FAILURE: 'USERINFO_LOAD_FAILURE',

    // 사용자 정보 변경
    UPDATE_REQUEST: 'USERINFO_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'USERINFO_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'USERINFO_UPDATE_FAILURE',

    // 비밀번호 변경
    PASSWORD_REQUEST: 'USERINFO_PASSWORD_REQUEST',
    PASSWORD_SUCCESS: 'USERINFO_PASSWORD_SUCCESS',
    PASSWORD_FAILURE: 'USERINFO_PASSWORD_FAILURE',

    // 주소변경
    CHANGE_ADDRESS: 'CHANGE_ADDRESS',

    // 탈퇴
    RETIRE_REQUEST: 'USERINFO_RETIRE_REQUEST',
    RETIRE_SUCCESS: 'USERINFO_RETIRE_SUCCESS',
    RETIRE_FAILURE: 'USERINFO_RETIRE_FAILURE',

    // 휴면설정
    INACTIVE_REQUEST: 'USERINFO_INACTIVE_REQUEST',
    INACTIVE_SUCCESS: 'USERINFO_INACTIVE_SUCCESS',
    INACTIVE_FAILURE: 'USERINFO_INACTIVE_FAILURE',

    // 전자지갑주소 발급 업데이트
    UPDATE_EWALLET_ID_REQUEST: 'USERINFO_UPDATE_EWALLET_ID_REQUEST',
    UPDATE_EWALLET_ID_SUCCESS: 'USERINFO_UPDATE_EWALLET_ID_SUCCESS',
    UPDATE_EWALLET_ID_FAILURE: 'USERINFO_UPDATE_EWALLET_ID_FAILURE',

    // 전자지갑주소 발급 업데이트
    DELETE_EWALLET_ID_REQUEST: 'USERINFO_DELETE_EWALLET_ID_REQUEST',
    DELETE_EWALLET_ID_SUCCESS: 'USERINFO_DELETE_EWALLET_ID_SUCCESS',
    DELETE_EWALLET_ID_FAILURE: 'USERINFO_DELETE_EWALLET_ID_FAILURE',

    //수정일자 업데이트
    MODDT_REQUEST: 'MODDT_REQUEST',
    MODDT_SUCCESS: 'MODDT_SUCCESS',
    MODDT_FAILURE: 'MODDT_FAILURE',

    // 디바이스 아이디
    SET_DEVICE_ID: 'SET_DEVICE_ID',

    /**소셜로그인등록 로그인 */
    ADD_SNSLOGIN_REQUEST: 'ADD_SNSLOGIN_REQUEST',
    ADD_SNSLOGIN_SUCCESS: 'ADD_SNSLOGIN_SUCCESS',
    ADD_SNSLOGIN_FAILURE: 'ADD_SNSLOGIN_FAILURE',

    /**소셜로그인 정보 조회 */
    SNSINFO_LOAD_REQUEST: 'SNSINFO_LOAD_REQUEST',
    SNSINFO_LOAD_SUCCESS: 'SNSINFO_LOAD_SUCCESS',
    SNSINFO_LOAD_FAILURE: 'SNSINFO_LOAD_FAILURE',

    /**소셜로그인 연동 해제 */
    DELETE_SNSINFO_REQUEST: 'DELETE_SNSINFO_REQUEST',
    DELETE_SNSINFO_SUCCESS: 'DELETE_SNSINFO_SUCCESS',
    DELETE_SNSINFO_FAILURE: 'DELETE_SNSINFO_FAILURE',

    /**공동인증서 signdata 저장 */
    SET_SIGNDATA: 'SET_SIGNDATA',

}